const getDeviceInfo = async ( userName ) => {
                const screenw = window.screen.width;
                const screenh = window.screen.height;
                const innerw = window.innerWidth;
                const innerh = window.innerHeight;
                const clientw = document.documentElement.clientWidth;
                const clienth = document.documentElement.clientHeight;
                const pratio = window.devicePixelRatio;
                const pdensity = window.screen.width / window.screen.height;
                const useragent = navigator.userAgent;
                const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                
                const deviceInfo = {
                    screenw: screenw,
                    screenh: screenh,
                    innerw: innerw,
                    innerh: innerh,
                    clientw: clientw,
                    clienth: clienth,
                    pratio: pratio,
                    pdensity: pdensity,
                    useragent: useragent,
                    isMobile: isMobile
                }
                return deviceInfo;
            }

export default getDeviceInfo;